import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import CompanyInsightSearch from './CompanyInsightSearch';
// import CompanyList from './CompanyList';
import DriverOverview from './DriverOverview';
import GenderAndDriverTypeCharts from './GenderAndDriverTypeCharts';
import LifeTimeChart from './LifeTimeChart';
import LifeTimeChurnChart from './LifeTimeChurnChart';
import OnboardingChart from './OnboardingChart';

const CompanyInsight = () => {
  return (
    <Page title='Logirate | Company Insights'>
      <PageLayout>
        <Container>
          <CompanyInsightSearch />
          <DriverOverview />
          <GenderAndDriverTypeCharts />
          <OnboardingChart />
          <LifeTimeChurnChart />
          <LifeTimeChart />
          {/* <CompanyList /> */}
        </Container>
      </PageLayout>
    </Page>
  );
};

export default CompanyInsight;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
`;
